import { userRegistrationApiSlice } from "./userRegistrationApiSlice";

export const userRegistrationApiManagemnetSlice =
  userRegistrationApiSlice.injectEndpoints({
    endpoints: (builder) => ({
      getGeoCodesZipCode: builder.query({
        query: (zip) => ({
          url: "/geo-code",
          method: "GET",
          headers: {
            zipCode: `${zip}`,
            key: "1av457dh-7d13-c6k8-7db8-6532f5js5271"
          },
        }),
      }),
      individualRegistarion: builder.mutation({
        query: (data) => ({
          url: "/individual",
          method: "POST",
          body: data,
        }),
      }),
      getAcgDetails: builder.query({
        query: (zip) => ({
          url: "/acg-details",
          method: "GET",
        }),
      }),
    }),
  });

export const {
  useGetGeoCodesZipCodeQuery,
  useIndividualRegistarionMutation,
  useGetAcgDetailsQuery,
} = userRegistrationApiManagemnetSlice;